import React from 'react';
import imgurl1 from 'url:../images/past_work/proj1_1.jpeg';
import imgurl2 from 'url:../images/past_work/proj1_2.jpeg';
import imgurl3 from 'url:../images/past_work/proj1_3.jpeg';
import imgurl4 from 'url:../images/past_work/proj1_4.jpeg';
import imgurl5 from 'url:../images/past_work/proj1_5.jpeg';
import imgurl6 from 'url:../images/past_work/proj1_6.jpeg';
import vid1 from 'url:../images/past_work/proj1_vid1.mp4';
import vid2 from 'url:../images/past_work/proj1_vid2.mp4';

import imgurl7 from 'url:../images/past_work/proj2_1.jpeg';

import imgurl8 from 'url:../images/past_work/proj3_1.jpeg';
import imgurl9 from 'url:../images/past_work/proj3_2.jpeg';
import imgurl10 from 'url:../images/past_work/proj3_3.jpeg';
import imgurl11 from 'url:../images/past_work/proj3_4.jpeg';

import imgurl12 from 'url:../images/past_work/proj4_1.jpeg';
import imgurl13 from 'url:../images/past_work/proj4_2.jpeg';
import imgurl14 from 'url:../images/past_work/proj4_3.jpeg';
import imgurl15 from 'url:../images/past_work/proj4_4.jpeg';
import imgurl16 from 'url:../images/past_work/proj4_5.png';

import imgurl17 from 'url:../images/past_work/proj5_1.jpeg';
import imgurl18 from 'url:../images/past_work/proj5_2.jpeg';
import imgurl19 from 'url:../images/past_work/proj5_3.jpeg';
import imgurl20 from 'url:../images/past_work/proj5_4.jpeg';
import imgurl21 from 'url:../images/past_work/proj5_5.png';

import imgurl22 from 'url:../images/past_work/proj6_1.jpeg';
import imgurl23 from 'url:../images/past_work/proj6_2.jpeg';
import imgurl24 from 'url:../images/past_work/proj6_3.jpeg';
import imgurl25 from 'url:../images/past_work/proj6_4.jpeg';
import imgurl26 from 'url:../images/past_work/proj6_5.jpeg';
import imgurl27 from 'url:../images/past_work/proj6_6.jpeg';

import imgurl28 from 'url:../images/past_work/proj7_1.jpeg';
import imgurl29 from 'url:../images/past_work/proj7_2.jpeg';
import imgurl30 from 'url:../images/past_work/proj7_3.jpeg';
import imgurl31 from 'url:../images/past_work/proj7_4.jpeg';

import imgurl32 from 'url:../images/past_work/proj8_1.jpeg';
import imgurl33 from 'url:../images/past_work/proj8_2.jpeg';

import imgurl34 from 'url:../images/past_work/proj9_1.jpeg';
import imgurl35 from 'url:../images/past_work/proj9_2.jpeg';
import imgurl36 from 'url:../images/past_work/proj9_3.jpeg';
import imgurl37 from 'url:../images/past_work/proj9_4.jpeg';
import imgurl38 from 'url:../images/past_work/proj9_5.jpeg';

import imgurl39 from 'url:../images/past_work/proj10_1.jpeg';
import imgurl40 from 'url:../images/past_work/proj10_2.jpeg';
import imgurl41 from 'url:../images/past_work/proj10_3.jpeg';
import imgurl42 from 'url:../images/past_work/proj10_4.jpeg';


import imgurl43 from 'url:../images/past_work/proj11_1.png';
import imgurl44 from 'url:../images/past_work/proj11_2.jpg';
import imgurl45 from 'url:../images/past_work/proj11_3.jpg';
import imgurl46 from 'url:../images/past_work/proj11_4.jpg';
import imgurl47 from 'url:../images/past_work/proj11_5.jpg';
// import imgurl48 from 'url:../images/past_work/proj11_6.png';
import imgurl49 from 'url:../images/past_work/proj11_7.jpeg';
import vid3 from 'url:../images/past_work/proj11_vid1.mp4';
import vid4 from 'url:../images/past_work/proj11_vid2.mp4';
import vid5 from 'url:../images/past_work/proj11_vid3.mp4';
import vid6 from 'url:../images/past_work/proj11_vid4.mp4';

import vid7 from 'url:../images/past_work/proj12_vid1.mp4';

import imgurl50 from 'url:../images/past_work/proj13_1.jpeg';
import imgurl51 from 'url:../images/past_work/proj13_2.jpeg';
import imgurl52 from 'url:../images/past_work/proj13_3.jpeg';
import imgurl53 from 'url:../images/past_work/proj13_4.jpeg';
import imgurl54 from 'url:../images/past_work/proj13_5.jpeg';
import imgurl55 from 'url:../images/past_work/proj13_6.jpeg';
import vid8 from 'url:../images/past_work/proj13_vid1.mp4';

import Carousel from "../components/ui/Carousel";

const createSlides = (media, projectNum) =>
    media.map((item, index) => ({
        type: typeof item === "object" ? item.type : "image",
        src: typeof item === "object" ? item.src : item,
        alt: `Project ${projectNum} Item ${index + 1}`,
    }));

function PastProjects() {

    const slides = {
        1: createSlides(
            [imgurl1, imgurl2, imgurl3, imgurl4, imgurl5, imgurl6, { type: "video", src: vid1 },
                { type: "video", src: vid2 }],
            1
        ),
        2: createSlides([imgurl7], 2),
        3: createSlides([imgurl8, imgurl9, imgurl10, imgurl11], 3),
        4: createSlides([imgurl12, imgurl13, imgurl14, imgurl15, imgurl16], 4),
        5: createSlides([imgurl17, imgurl18, imgurl19, imgurl20, imgurl21], 5),
        6: createSlides(
            [imgurl22, imgurl23, imgurl24, imgurl25, imgurl26, imgurl27],
            6
        ),
        7: createSlides([imgurl28, imgurl29, imgurl30, imgurl31], 7),
        8: createSlides([imgurl32, imgurl33], 8),
        9: createSlides([imgurl34, imgurl35, imgurl36, imgurl37, imgurl38], 9),
        10: createSlides([imgurl39, imgurl40, imgurl41, imgurl42], 10),
        11: createSlides(
            [imgurl43, imgurl44, imgurl45, imgurl46, imgurl47, imgurl49, { type: "video", src: vid3 },
                { type: "video", src: vid4 }, { type: "video", src: vid5 }, { type: "video", src: vid6 }],
            11
        ),
        12: createSlides(
            [{ type: "video", src: vid7 }],
            12
        ),
        13: createSlides([imgurl50, imgurl51, imgurl52, imgurl53, imgurl54, imgurl55, { type: "video", src: vid8 }], 13),
    };

    const projects = [
        {
            id: 13,
            date: "July 2026",
            slides: slides[13],
            content: (
                <>
                    <p>
                        First aid to a civilian driver:
                    </p>

                    <p>
                        That morning in July, a Russian FPV drone of the "Molniya" ("Lightning") type struck a civilian car driving between villages close to the frontline. The impact threw the car against the metal poles supporting a protective road net, which is not designed to stop ammunition. A paramedic team from the 32nd Brigade found the injured driver while traveling along the same road in a cross-country truck recently supplied by Ukraine-Hilfe. In the video and pictures, paramedic Lera is seen applying a bandage to the driver's head.
                    </p>
                </>
            ),
        },

        {
            id: 12,
            date: "June 2026",
            slides: slides[12],
            content: (
                <>
                    <p>
                        Ukrainian Warriors of 225 Separate Assault Batallion say in this short video:
                    </p>

                    <p>
                        "In the name of the UAV Unit of 225 Separate Assault Batallion we express our
                        great appreciation to the non-profit organization "Ukraine -Hilfe" for the
                        purchase and delivery of this offroad vehicle to our unit. This car will be used
                        for evacuation tasks within the Zaporizzhja operational area. This truck will save
                        lifes of Ukrainian fighters as well as civilians living in the war zone. Thank you for
                        staying by us and helping our forces. Glory to Ukraine! Glory to heroes!"
                    </p>
                </>
            ),
        },

        {
            id: 11,
            date: "April 2026",
            slides: slides[11],
            content: (
                <>
                    <p>
                        Ukraine-Hilfe has brought another small convoy to Ukraine.
                        While traveling through Germany, we loaded fire extinguishers,
                        which were eventually delivered to our friends in the 127th
                        Brigade in the Kharkiv region, along with the trucks.
                    </p>

                    <p>
                        Quoting the officer: "The fighters of the 2nd mechanized battalion of
                        127 brigade repeatedly express their gratitude to Ukraine-Hilfe for
                        their help and delivery of yet another evacuation car. It will be
                        forwarded towards Vovchansk where it will defend our country and save lifes.
                        Slava Ukraine!"
                    </p>
                </>
            ),
        },

        {
            id: 10,
            date: "April 2026",
            slides: slides[10],
            content: (
                <p>
                    This almost-new quadricycle is about to be delivered to our
                    friends in the 127th Territorial Defence, who are fighting in
                    the Kupjansk direction.
                </p>
            ),
        },

        {
            id: 9,
            date: "March 2026",
            slides: slides[9],
            content: (
                <p>
                    Together with Adolf-Reichwein-Gymnasium, Ukraine-Hilfe e.V.
                    hosted a panel discussion featuring two members of the German
                    Parliament, Omid Nouripour and Markus Koob, the former serving
                    as a Vice President of the Bundestag. Other guests included
                    Boris Zimin, a business investor, as well as Igor Tartakovski,
                    the chairman of our organization. We were particularly honored
                    to have two officers of the Ukrainian Defence Forces join us via
                    video conference.

                    <br /><br />

                    The discussion addressed a wide range of topics, from the
                    origins of Russia’s aggression against Ukraine to the
                    positioning of Germany and other countries in response to
                    rapidly evolving security threats, as well as the most urgent
                    current needs on the front lines. Approximately 300 students
                    attended the event and engaged actively by asking additional
                    questions to the panel.

                    <br /><br />

                    Recordings of parts of the event (with English subtitles) are
                    available on our{" "}
                    <a
                        href="https://www.youtube.com/@Ukraine-Hilfe-BadHomburg"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        YouTube channel
                    </a>.
                </p>
            ),
        },

        {
            id: 1,
            date: "December 2025",
            slides: slides[1],
            content: (
                <>
                    <p>
                        Ukraine-Hilfe e.V., together with Techno Varta, purchased
                        and shipped four trucks to the 127th Brigade of the
                        Territorial Defence. This short photo story shows the
                        journey of one of the vehicles: shortly after purchase,
                        during shipment by ferry, and later crossing Ukraine with a
                        stop at a gas station along the way. After the long
                        delivery, the trucks were handed over at Freedom Square in
                        Kharkiv.
                    </p>

                    <p>
                        The vehicle was immediately deployed to the front line for
                        use as a medevac. Just one week later, it was attacked by a
                        Russian drone. Thankfully, there were no casualties, but the
                        truck sustained serious damage. In the final image, one of
                        the soldiers is seen attempting to repair the vehicle so it
                        could reach the garage without being towed. Despite major
                        repairs still ahead, we are proud that this truck helped
                        defend Ukrainian land in the Kupiansk direction.
                    </p>
                </>
            ),
        },

        {
            id: 8,
            date: "July 2025",
            slides: slides[8],
            content: (
                <p>
                    A car was delivered to the UAV batallion of the 93 Brigade. The
                    handover is not pictured so as not to disclose the faces of the
                    UAV unit.
                </p>
            ),
        },

        {
            id: 7,
            date: "June 2025",
            slides: slides[7],
            content: (
                <p>
                    A truckload of mask nets and potable water were delivered to the
                    93rd Brigade.
                </p>
            ),
        },

        {
            id: 6,
            date: "April 2025",
            slides: slides[6],
            content: (
                <>
                    <p>
                        A truck was delivered to the 93rd Mechanized Brigade. To
                        learn more about the garage inspection and fitting of the
                        vehicle, please visit our partner organization Techno
                        Varta’s Facebook page:
                        (
                        <a
                            href="https://www.facebook.com/share/v/1BjxBR8QLa/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            1
                        </a>
                        ,{" "}
                        <a
                            href="https://www.facebook.com/share/v/16RWtE6VNR/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            2
                        </a>
                        )
                    </p>

                    <p>
                        The letter written from the commander of the 93rd Brigade,
                        Shamil Krutkow, reads:
                        <br /><br />
                        “The officers and staff of military unit A1302 are grateful
                        for the assistance you have provided. Without a doubt, the
                        civil position you take and your hard and selfless work are
                        a substantial contribution to the fighting capacity of the
                        Ukrainian Armed Forces.”
                    </p>
                </>
            ),
        },

        {
            id: 5,
            date: "March 2025",
            slides: slides[5],
            content: (
                <p>
                    A truck with a spare engine was delivered to the 72nd
                    Mechanized Brigade.
                </p>
            ),
        },

        {
            id: 4,
            date: "February 2025",
            slides: slides[4],
            content: (
                <p>
                    This Nissan X-Trail was delivered to the 33rd Mechanized
                    Brigade, in one of the most difficult battle zones near
                    Pokrovsk. Officers noted the vehicle’s good technical condition.
                    The car was delivered by our partner Techno Varta.
                </p>
            ),
        },

        {
            id: 3,
            date: "May 2024",
            slides: slides[3],
            content: (
                <p>
                    Ukraine-Hilfe e.V. provided a medevac pickup truck and supplies
                    for a new field medicine unit.
                </p>
            ),
        },

        {
            id: 2,
            date: "December 2024",
            slides: slides[2],
            content: (
                <p>
                    The Nissan vehicle (left) was delivered to the 21st Separate
                    Cavalry Brigade by our partner Techno Varta.
                </p>
            ),
        },
    ];

    return (
        <section>
            <h2 className="text-2xl font-semibold mb-4 text-center">Past Projects</h2>
            {projects.map((project) => (
                <div className="project-container" key={project.id}>
                    <div className="project-box">
                        <div className="project-media">
                            <Carousel slides={project.slides} />
                        </div>

                        <div className="project-text">
                            <div className="project-date">
                                {project.date}
                            </div>

                            {project.content}
                        </div>
                    </div>
                </div>
            ))}
        </section>
    )
}

export default PastProjects